import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Instagram, Youtube, Facebook, Linkedin, Twitter, Music2 } from "lucide-react";
import { api } from "@/lib/api";
import { Logo } from "@/components/Logo";

const ICONS = { instagram: Instagram, tiktok: Music2, youtube: Youtube, x: Twitter, facebook: Facebook, linkedin: Linkedin };

export const Footer = () => {
  const [links, setLinks] = useState({});
  useEffect(() => { api.get("/site/social").then(({ data }) => setLinks(data)).catch(() => {}); }, []);
  const active = Object.entries(links).filter(([, v]) => v);

  return (
    <footer className="border-t border-white/10 mt-20" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-10 flex flex-col md:flex-row gap-8 md:items-center justify-between">
        <div className="flex items-center gap-3">
          <Logo size={34} />
          <div>
            <div className="text-white font-bold">Hustler's Campus</div>
            <div className="text-xs text-slate-500">Share what you know. Build wealth together.</div>
          </div>
        </div>
        <div className="flex items-center gap-5 text-sm text-slate-400">
          <Link to="/campus" data-testid="footer-courses" className="hover:text-amber-400">Courses</Link>
          <Link to="/teach" data-testid="footer-teach" className="hover:text-amber-400">Teach</Link>
          {active.map(([k, url]) => {
            const Icon = ICONS[k];
            return (
              <a key={k} href={url} target="_blank" rel="noreferrer" aria-label={k} data-testid={`footer-social-${k}`}
                className="h-9 w-9 rounded-full border border-white/10 flex items-center justify-center hover:border-amber-500 hover:text-amber-400 transition-colors">
                <Icon className="h-4 w-4" />
              </a>
            );
          })}
        </div>
      </div>
    </footer>
  );
};
